import { DESIGN_SLUGS, resolveDesignSlug } from "@/lib/utils/design-slug";

const COOKIE_NAME = "design";
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export function readDesignCookie(cookieHeader: string): string {
  const entry = cookieHeader
    .split("; ")
    .find((pair) => pair.startsWith(`${COOKIE_NAME}=`));
  return resolveDesignSlug(entry?.slice(COOKIE_NAME.length + 1));
}

export function writeDesignCookie(slug: string): boolean {
  if (!DESIGN_SLUGS.some((known) => known === slug)) return false;
  document.cookie = `${COOKIE_NAME}=${slug}; path=/; max-age=${ONE_YEAR_SECONDS}; samesite=lax`;
  return true;
}
